import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import { Modal } from "react-bootstrap";
import swal from "sweetalert";
import {
  recruiterPlanHistory,
  updatePlan,
} from "../../../services/SubRecruiterService";
import { categoryPlanListAPI } from "../../api/plan";
import { downloadCSV } from "../../../helpers/dataTableHelper";

function RecruiterPlanHistory() {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [planlist, setPlanList] = useState([]);
  const [plan, setPlan] = useState({ plan: "", is_error: false });
  const [addModel, setAddModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [reqParams, setReqParams] = useState({
    page: currentPage,
    limit: perPage,
    sort_by: "id",
    sort_direction: "DESC",
    recruiter_id: id,
  });

  const [fetch, setFetch] = useState(true);

  const fetchUsers = useCallback(
    (params) => {
      //setToggleCleared(!toggleCleared);
      setLoading(true);
      recruiterPlanHistory(params)
        .then((res) => {
          setData(res?.data?.data?.data);
          setTotalRows(res?.data?.data.totalRecords);
          setLoading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          //console.log(err);
          setLoading(false);
          setFetch(false);
        });
    },
    [setFetch]
  );

  const fetchData = useCallback(async () => {
    let plan = await categoryPlanListAPI();
    setPlanList(plan);
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (fetch) {
      fetchUsers(reqParams);
    }
  }, [fetch, reqParams]);

  const columns = useMemo(
    () => [
      {
        name: "Actions",
        button: "true",
        width: "150px",
        cell: (row) => {
          return (
            // <button
            //   className="btn btn-sm btn-outline-warning me-2"
            //   //onClick={() => onEdit(row)}
            // >
            //   <i className="fa fa-edit"></i>
            // </button>
            <Link
              to={"/" + row?.bill_id + "/" + id + "/history-details"}
              className="btn btn-sm btn-outline-warning"
            >
              <i className="fa fa-history"></i>
            </Link>
          );
        },
      },
      {
        name: "Plan Name",
        selector: (row) => row.plan_name + " (" + row.plan_id + ")",
        wrap: true,
        width: "200px",
        sortable: true,
        sortField: "plan_name",
      },
      {
        name: "Category Name",
        selector: (row) => row.category_name,
        wrap: true,
        width: "200px",
        sortable: true,
        sortField: "category_name",
      },
      {
        name: "Plan Expire",
        selector: (row) => row.expiry_date,
        wrap: true,
        width: "200px",
        sortable: true,
        sortField: "expiry_date",
      },
      {
        name: "Total Unlock",
        selector: (row) => row.total_unlocked_remaining,
        wrap: true,
        width: "120px",
        //sortable: true,
        //sortField: "preferred_name",
      },
      {
        name: "Unlock General",
        selector: (row) => row.general_unlocked_remaining,
        wrap: true,

        width: "140px",
        //sortable: true,
        //sortField: "preferred_name",
      },
      {
        name: "Unlock Application",
        selector: (row) => row.applicants_unlocked_remaining,
        wrap: true,
        width: "150px",
        //sortable: true,
        //sortField: "preferred_name",
      },
      {
        name: "Total Jobs",
        selector: (row) => row.posted_jobs_remaining,
        wrap: true,
        width: "100px",
        //sortable: true,
        //sortField: "preferred_name",
      },
      {
        name: "Total Sub-recruiter",
        selector: (row) => row.subrecruiter_remaining_quota,
        wrap: true,
        width: "150px",
        //sortable: true,
        //sortField: "preferred_name",
      },
      {
        name: "Offers",
        selector: (row) => row.offers,
        wrap: true,
        width: "100px",
        //sortable: true,
        //sortField: "preferred_name",
      },
    ],
    []
  );

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        limit: newPerPage,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleSort = useCallback(
    (column, sortDirection) => {
      if (column?.sortField !== undefined) {
        setReqParams({
          ...reqParams,
          sort_by: column.sortField,
          sort_direction: sortDirection,
        });
        setFetch(true);
      }
    },
    [reqParams, setReqParams, setFetch]
  );

  const handleAdd = useCallback(
    (e) => {
      e.preventDefault();

      if (plan?.plan === "") {
        setPlan({ ...plan, is_error: true });
      }

      updatePlan({ recruiter_id: id, plan_id: plan?.plan })
        .then((res) => {
          console.log(res);
          e.target.reset();
          setPlan({ plan: "", is_error: false });
          setAddModal(false);
          swal("Great Job!", res?.data.message, "success");
        })
        .catch((err) => console.log(err));
    },
    [setFetch, plan]
  );

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap">
        <div>
          <button
            onClick={() => setAddModal(true)}
            className="btn btn-info me-3 btn-sm"
          >
            <i className="fas fa-refresh me-1"> </i>Update Plan
          </button>
        </div>
        <div className="text-end">
          <button
            onClick={() => downloadCSV(data, "recruiter-plan-history-")}
            className="btn btn-warning btn-sm me-2"
          >
            <i className="fas fa-file-csv me-1"></i> Export
          </button>
          <Link to={"/recruiter_list"} className="btn btn-primary btn-sm">
            <i className="fa fa-arrow-left"></i> Back
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <DataTable
              columns={columns}
              data={data}
              progressPending={loading}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              persistTableHead
              onSort={handleSort}
              sortServer
              fixedHeader={true}
              fixedHeaderScrollHeight={"500px"}
            />
          </div>
        </div>
      </div>
      <Modal
        className="modal fade"
        size="lg"
        show={addModel}
        onHide={setAddModal}
        keyboard={false}
        backdrop="static"
      >
        <div role="document">
          <div className="">
            <div className="modal-header">
              <h4 className="modal-title fs-20">Update New Plan</h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setAddModal(false)}
                data-dismiss="modal"
              >
                <span></span>
              </button>
            </div>
            <form onSubmit={handleAdd}>
              <div className="modal-body">
                <i
                  className="flaticon-cancel-12 close"
                  data-dismiss="modal"
                ></i>
                <div className="add-contact-box">
                  <div className="add-contact-content">
                    <div className="add-contact-box">
                      <div className="add-contact-content">
                        <div className="mb-3 form-group">
                          <label>
                            Select Plan
                            <span style={{ color: "red" }}>*</span>
                          </label>

                          <select
                            id="qualification"
                            onChange={(e) =>
                              setPlan({ ...plan, plan: e.target.value })
                            }
                            className="form-select"
                            name="qualification"
                            defaultValue={plan?.plan}
                          >
                            <option value="">Select Plan</option>
                            {planlist.map((plan, i) => (
                              <optgroup key={i} label={plan.name}>
                                {plan.plans.map((pln) => (
                                  <option key={pln.plan_id} value={pln.plan_id}>
                                    {pln.plan_name}
                                  </option>
                                ))}
                              </optgroup>
                            ))}
                          </select>
                          {plan?.is_error && (
                            <div className="invalid-feedback d-block">
                              Please select plan
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-between">
                <div>
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    //disabled={imageUploading.uploding}
                  >
                    <i className="fa fa-save"></i> Save
                  </button>
                  <button
                    type="button"
                    onClick={() => setAddModal(false)}
                    className="btn btn-danger"
                  >
                    <i className="fa fa-times"></i> Close
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default RecruiterPlanHistory;
